module.exports = __webpack_public_path__ + "static/media/pomodoroClock.806671f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pomodoroClock.jpg
// module id = 75
// module chunks = 0